import * as React from "react";
export default function Hero() {
  return <section data-section-id="236500" id="connect-hero" role="img" aria-label="ABCO South Electrical Construction and Design and Automation" className="relative flex min-h-[60vh] items-center justify-center !bg-[url(https://amusing-monitor.10web.cloud/wp-content/uploads/2026/05/IMG_0935-scaled.jpeg)] bg-cover bg-center py-32 bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

      {}
      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center px-4 text-center md:px-8">
        
        
        
      </div>
    </section>;
}